var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGleapBotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5938,
    y: 11.5234,
    width: 5.53125,
    height: 14.75,
    rx: 2.76562,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.875,
    y: 11.5234,
    width: 5.53125,
    height: 14.75,
    rx: 2.76562,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6107 38.2128C40.8944 38.9233 40.7078 39.7235 40.3566 40.4032C38.1724 44.6296 34.655 46.8646 29.9251 47.0697C25.3091 47.2698 21.5314 45.3472 19.1003 41.3438C18.5168 40.383 18.2067 38.7513 18.6417 37.8471C18.9532 37.1996 20.713 37.0466 21.8333 37.0253C27.0362 36.9263 32.2441 37.0397 37.4444 36.8827C38.951 36.8372 40.1095 36.9576 40.6107 38.2128Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGleapBotIcon);
export default __webpack_public_path__ + "static/media/GleapBotIcon.2b00526f6a6d6ea016f63201b185742e.svg";
export { ForwardRef as ReactComponent };